import { SET_IS_PROSPECTOR_OWNER } from '../../actions/dsr-actions-types'

const INITIAL_STATE_SET_IS_PROSPECTOR_OWNER = { isProspectorOwner: '' }

export function setIsProspectorOwnerReducer(state = INITIAL_STATE_SET_IS_PROSPECTOR_OWNER, action) {
    switch (action.type) {
        case SET_IS_PROSPECTOR_OWNER:
            return { isProspectorOwner: action.payload }
        default:
            return state;
    }
}